import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DataCardService } from './data-card.service';
import { DataCardComponent } from './data-card/data-card.component';
import { DataCardTblComponent } from './data-card-tbl/data-card-tbl.component';
import { DataCardDatesComponent } from './data-card-dates/data-card-dates.component';

@NgModule({
  imports: [
    CommonModule
  ],
  exports: [
        DataCardComponent,
        DataCardTblComponent,
        DataCardDatesComponent
    ],
    declarations: [
        DataCardComponent,
        DataCardTblComponent,
        DataCardDatesComponent
    ],
    providers: [DataCardService],
    entryComponents: [
        DataCardComponent,
        DataCardTblComponent,
        DataCardDatesComponent
    ],
})
export class DataCardsModule { }



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/brds/widgets/data-cards/data-cards.module.ts